export default __webpack_public_path__ + "static/media/hello-dark.10be382e.svg";